// IMPORT LANGUAGE FILES FROM MODULES
var langFiles = {
    en: {
        locale: "en",
        name: "English,",
        lang: {},
    },
    es: {
        locale: "es",
        name: "Spanish,",
        lang: {},
    },
};

/* Require all language files from core */
const coreLangFiles = require.context(
    "Core", // current directory
    true, // subdirectories
    /lang\.[a-zA-Z0-9_]+\.js$/ // only .js
);

coreLangFiles.keys().forEach((filename) => {
    var nextFile = coreLangFiles(filename).default || coreLangFiles(filename);

    const language = filename
        .substring(filename.lastIndexOf("/") + 1)
        .replace(/lang\./g, "")
        .replace(/.js/g, "");

    Object.assign(langFiles[language].lang, nextFile);
});

/* Require all language files from modules */
const moduleLangFiles = require.context(
    "Modules", // current directory
    true, // subdirectories
    /lang\.[a-zA-Z0-9_]+\.js$/ // only .js
);

moduleLangFiles.keys().forEach((filename) => {
    var nextFile = moduleLangFiles(filename).default || moduleLangFiles(filename);

    const language = filename
        .substring(filename.lastIndexOf("/") + 1)
        .replace(/lang\./g, "")
        .replace(/.js/g, "");

    Object.assign(langFiles[language].lang, nextFile);
});

// console.log(langFiles);
export default langFiles;
